import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import BodyWrap from "../../utils/BodyWrap";
import GeneralLoader from "../../GeneralLoader";
import ErrorWrap from "../../utils/error-success/ErrorWrap";
import SuccessWrap from "../../utils/error-success/SuccessWrap";
import Button from "../../utils/Button";

// CSS
import "../../../css/forms/password-input.css";

// State
import { getTranslations } from "../../../store/actions/translations";
import { getReviewer } from "../../../store/actions/reviewers";
import { resetChangePasswordSuccess, clearErrors, userLogout, changePassword } from "../../../store/actions/user";

// Utils
import {
	handleKeyPress,
	handleInputChange
} from "../../../utils/forms/inputHandling";

class ChangePassword extends Component{
    constructor(props) {
		super(props);
		this.state = {
			data: {
                password_current: "",
                password_new: "",
                password_new_confirm: "",
			},
            // Handle show/hiding password in the input fields
            password_show: false,
            password_new_show: false,
            password_new_confirm_show: false
		};
	}

    static initialAction(store, props, translationKey = null) {
		const reviewer = store !== null ? store.getState().user.reviewer : props.reviewer;
		const promises = [];
		const translationSections = [
			"reviewer_change_password",
			"buttons",
			"form_elements",
			"languages"
		];

		if (translationKey === null) {
			translationKey = props.translationKey;
		}

		if (!reviewer) {
			if (store !== null) {
				promises.push(userLogout("reviewer"));
			} else {
				promises.push(props.userLogout("reviewer"));
			}
		} else {
			if (store !== null) {
				promises.push(getReviewer(reviewer.user.id, reviewer.token));
				promises.push(
					getTranslations([translationKey], translationSections, translationKey)
				);
			} else {
				promises.push(props.getReviewer(reviewer.user.id, reviewer.token));
				promises.push(
					props.getTranslations([translationKey], translationSections, translationKey)
				);
			}
		}

		return promises;
	}

	/*
	 * If component got new props, we should check if things are persisted.
	 * If so, go get the reviewer and translations
	 */
	componentDidUpdate(prevProps) {
		if (this.props.persisted && prevProps.persisted === false) {
			Promise.all(ChangePassword.initialAction(null, this.props));
		}
	}

	/*
	 * Component mounts and things are already persisted, just go get reviewer info
	 */
	componentWillMount() {
		if (this.props.persisted) {
			Promise.all(ChangePassword.initialAction(null, this.props));
		}
	}

	componentWillUnmount() {
        this.props.clearErrors();
		this.props.resetChangePasswordSuccess();
	}

    // Show/Hide password in input fields
    togglePassword(id){
        this.setState({
            [id]: !this.state[id]
        })
    }

    // ===================================
	//  SUBMIT
	// ===================================
    handleSubmit = () => {
        this.props.changePassword(
            this.state.data.password_current,
            this.state.data.password_new,
            this.state.data.password_new_confirm
        );
    }

    render() {
        const { success, isLoading, reviewerIsLoading, translationsLoading, translations } = this.props;
        const { data, password_show, password_new_show, password_new_confirm_show } = this.state;

        return (
            <div className="body_container padded_top padded_bottom">
                <BodyWrap>
                    {translationsLoading ? (
						<GeneralLoader />
					) : (
                        <React.Fragment>
                            <div className="content-header">
                                <h1>{translations.sections.reviewer_change_password.change_password_title}</h1>
                                <div className="page-text">{translations.sections.reviewer_change_password.change_password_content}
                                </div>
                            </div>
                            <div className="centered-form">
                                {!reviewerIsLoading ? (
                                    <GeneralLoader />
                                ) : (
                                    <div className="form-content">
                                        <div className="form-field pb2">
                                            <label htmlFor="password_current">
                                                Enter Current Password:
                                            </label>

                                            {this.props.errors.password_current && (
                                                <ErrorWrap animate={1}>{this.props.errors.password_current}</ErrorWrap>
                                            )}
                                            <div className="password-form">
                                                <input
                                                    type={password_show ? 'text' : 'password'}
                                                    name="password_current"
                                                    id="password_current"
                                                    disabled={isLoading}
                                                    value={data.password_current}
                                                    onKeyPress={e => handleKeyPress(e, this.handleSubmit)}
                                                    onChange={e => this.setState(handleInputChange(e, this.state))}
                                                />
                                                <button onClick={() => this.togglePassword('password_show')}>{password_show ? 'Hide' : 'Show'}</button>
                                            </div>
                                            
                                        </div>
                                        <div className="form-field">
                                            <label htmlFor="password_current">
                                                Enter New Password:
                                            </label>

                                            {this.props.errors.password_new && (
                                                <ErrorWrap animate={1}>{this.props.errors.password_new}</ErrorWrap>
                                            )}
                                            <div className="password-form">
                                                <input
                                                    type={password_new_show ? 'text' : 'password'}
                                                    name="password_new"
                                                    id="password_new"
                                                    disabled={isLoading}
                                                    value={data.password_new}
                                                    onKeyPress={e => handleKeyPress(e, this.handleSubmit)}
                                                    onChange={e => this.setState(handleInputChange(e, this.state))}
                                                />
                                                <button onClick={() => this.togglePassword('password_new_show')}>{password_new_show ? 'Hide' : 'Show'}</button>
                                            </div>

                                        </div>
                                        <div className="form-field">
                                            <label htmlFor="password_new_confirm">
                                                Confirm New Password:
                                            </label>

                                            {this.props.errors.password_new_confirm && (
                                                <ErrorWrap animate={1}>{this.props.errors.password_new_confirm}</ErrorWrap>
                                            )}
                                            <div className="password-form">
                                                <input
                                                    type={password_new_confirm_show ? 'text' : 'password'}
                                                    name="password_new_confirm"
                                                    id="password_new_confirm"
                                                    disabled={isLoading}
                                                    value={data.password_new_confirm}
                                                    onKeyPress={e => handleKeyPress(e, this.handleSubmit)}
                                                    onChange={e => this.setState(handleInputChange(e, this.state))}
                                                />
                                                <button onClick={() => this.togglePassword('password_new_confirm_show')}>{password_new_confirm_show ? 'Hide' : 'Show'}</button>
                                            </div>
                                        </div>

                                        {success ? (
                                            <div className="pt2">
                                                <SuccessWrap>
                                                    {
                                                        translations.sections.reviewer_change_password
                                                            .success_message
                                                    }
                                                </SuccessWrap>
                                            </div>
                                        ) : <React.Fragment></React.Fragment>
                                        }
                                        <div className="pt2">
                                            {this.props.errors.general && (
                                                <ErrorWrap animate={1}>{this.props.errors.general}</ErrorWrap>
                                            )}
                                            <Button
                                                text={'Submit'}
                                                clickHandler={this.handleSubmit}
                                                disabled={isLoading}
                                                {...this.props}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </React.Fragment>
                    )}
                </BodyWrap>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
	return {
		translationsLoading:
			state.translations.isLoading[props.translationKey] === undefined
				? 1
				: state.translations.isLoading[props.translationKey],
		translations: state.translations.translations,
        errors: state.user.changePasswordErrors,
		success: state.user.changePasswordSuccess,
		isLoading: state.user.isLoading,
		persisted: state.persist,
		reviewer: state.user.reviewer,
		reviewerIsLoading: !!state.reviewers.isLoading ? state.reviewers.isLoading : 1
	};
};

export default connect(
	mapStateToProps,
	{ getReviewer, resetChangePasswordSuccess, clearErrors, userLogout, getTranslations, changePassword }
)(ChangePassword);


// WEBPACK FOOTER //
// ./src/components/reviewer/profile/ChangePassword.js